exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlight-category[data-v-837a629e]{border-style:solid;border-width:1px;background-color:#fafafa;border-color:#f1f1f1;color:#8a8a8a}.product-tree-collapse .product-tree-collapse-title[data-v-837a629e]{cursor:pointer;font-size:1.35em;color:#000;opacity:.75}.product-tree-collapse .product-tree-collapse-title .icon[data-v-837a629e]{vertical-align:text-bottom;transition:.3s}.product-tree-collapse .product-tree-collapse-title[data-v-837a629e]:hover{opacity:1}.product-tree-collapse .product-tree-collapse-title.title-bg-grey[data-v-837a629e]{background-color:#f7f7f7}", ""]);

// exports
